export const customerlMessages = {
  max_length: "255英字以下でご指定ください。",
  required: "この項目は必須です。",
  memo_max_length: "メモは255文字以下にしてください。",
  next_call_time: "再TELの形式は、「YYYY-MM-DD」と合いません。",
};
